import { forwardRef } from "react";
import { useId } from "react";
function SvgRawQuizIcon({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        stroke="#545454"
        strokeWidth={2}
        d="M18 9c0 3.38-4 4.533-4 8h-4c0-3.467-4-4.128-4-8 0-3 2.239-6 6-6s6 3 6 6Z"
      />
      <path
        stroke="currentColor"
        strokeWidth={2}
        d="M10 21c0 .552.895 1 2 1s2-.448 2-1h-4Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawQuizIcon);
export default ForwardRef;
